import { createContext } from 'react';
interface INavbarProps {
	sidebarHelpState: string;
	setSidebarHelpState: React.Dispatch<React.SetStateAction<string>>;
}
export const NavbarContext = createContext({} as INavbarProps);
